var levelOfAWSUsage = {
	"Level of AWS usage": "Grad der AWS-Nutzung",
	"Do not use AWS today": "Noch keine Verwendung von AWS",
	"Evaluating/experimenting with AWS": "Testen/Experimentieren mit AWS",
	"Run dev/test workloads on AWS": "Ausführung von Entwicklungs-/Test-Workloads in AWS",
	"Run a production workload on AWS": "Ausführung einer einzelnen Produktions-Workload in AWS",
	"Run multiple production workloads on AWS": "Ausführung mehrerer Produktions-Workloads in AWS"
};

export { levelOfAWSUsage as default };
